export const versionInfo = {
  "version": "1.0.778",
  "build": "26453",
  "commit": "06d519d00b24e44d189b667e64677dc116048f49"
}
